// Generated from SVG to Code Figma Plugin

export const ReferenceMaterial = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.3327 11.9998C20.3327 16.6022 16.6017 20.3332 11.9993 20.3332C7.39698 20.3332 3.66602 16.6022 3.66602 11.9998C3.66602 7.39746 7.39698 3.6665 11.9993 3.6665"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.64"
      d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.64"
      d="M12.0007 13.6668C12.9211 13.6668 13.6673 12.9206 13.6673 12.0002C13.6673 11.0797 12.9211 10.3335 12.0007 10.3335C11.0802 10.3335 10.334 11.0797 10.334 12.0002C10.334 12.9206 11.0802 13.6668 12.0007 13.6668Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 12L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 6V3L15 6V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 6H21L18 9H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
